<template>
    <div>
<!--        <strong>{{ $_.get(activity, "actorUser.name") }}</strong>-->
<!--        Fatura Detayını Güncelledi-->
        <span v-html="$t('notification.billingAddressUpdated', {user: $_.get(activity, 'actorUser.name') })"></span>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "BillingAddressUpdated",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style scoped lang="scss"></style>
